import React, { useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import useNebula from 'hooks/useNebula';
import AppContext from '../AppContext';

const styles = () => ({
  viz: {

  },
});

const Donut = ({
  classes,
}) => {
  const qlikApp = useContext(AppContext);

  const nebula = useNebula(qlikApp);
  const donutRef = useRef();
  const donutVizRef = useRef();

  useEffect(async () => {
    if (!nebula) return;

    donutVizRef.current = await nebula.render({
      element: donutRef.current,
      type: 'donut',
      fields: [
        {
          qDef: {
            qFieldDefs: ['Match Period'],
            qSortCriterias: [
              {
                qSortByExpression: -1,
                qExpression: {
                  qv: "=Num(Count(distinct goal_id) / count(total goal_id) * 100,'##.0')&'%'",
                },
              },
            ],
            autoSort: false,
          },
        },
        {
          qDef: {
            qDef: "=Num(Count(distinct goal_id) / count(total goal_id) * 100,'##.0')&'%'",
          },
        },
      ],
    });
  }, [nebula]);

  return (
    <>
      <div id="donutViz" className={classes.viz} ref={donutRef} style={{ height: 450 }} />
    </>
  );
};

Donut.propTypes = {
  classes: PropTypes.object.isRequired,
};

Donut.defaultProps = {
};

export default injectSheet(styles)(Donut);
